import { render, staticRenderFns } from "./CmgLeaderboardFavorite.vue?vue&type=template&id=2bd1b264&scoped=true&lang=pug"
import script from "./cmg-leaderboard-favorite.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-favorite.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardFavorite.vue?vue&type=style&index=0&id=2bd1b264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd1b264",
  null
  
)

export default component.exports